import React, { Component } from 'react';
import YouTubeContainer from './YouTubeContainer';
import CarouselNav from './CarouselNav';
import '../Assets/Styles/Carousel.css';

import classNames from 'classnames'

class Carousel extends Component {

  constructor() {
    super();
    this.state = {
      currentSlide: 1
    }
  }

  componentWillUpdate(nextProps, nextState){
    if(nextProps.active !== this.props.active){
      
    }
  }

  prevSlide() {
    console.log(this.state.currentSlide);
    if (this.state.currentSlide === 1) {
      this.setState({
        currentSlide: this.props.slides.length
      });
    } else {
      this.setState((prevState) => ({
        currentSlide: prevState.currentSlide - 1
      }));
    }
  }

  nextSlide() {
    console.log(this.state.currentSlide);
    if (this.state.currentSlide === this.props.slides.length) {
      this.setState({
        currentSlide: 1
      });
    } else {
      this.setState((prevState, props) => ({
        currentSlide: prevState.currentSlide + 1
      }));
    }
  }

  newSlide(index){
    this.setState({currentSlide: index})
  }

  isActive(slide_id) {
    return (slide_id === this.state.currentSlide && this.props.active)
  }

  render() {
    let slides = this.props.slides;
    let carouselNav;

    if(slides) {
      slides = slides.map((slide, i) => {
        let formattedSlide;
        let isActive = this.isActive(i + 1);
        let slideClasses = classNames({
          carouselImage: true,
          active: isActive
        });
        let styles = {
          'backgroundImage': 'url( ' + slide + ')'
        }
        if(this.props.format === "images") {
          formattedSlide = <div key={i} style={styles} className={slideClasses}><img src={slide} alt=""/></div>;
          carouselNav = <CarouselNav length={slides.length} current={this.state.currentSlide} handleNavigation={this.newSlide.bind(this)}/>
        } else if (this.props.format === "videos") {
          formattedSlide = <YouTubeContainer key={i} videoId={slide} active={isActive} />
        }
        return (
          formattedSlide
        )
      });
    }

    return (
      <div className="Carousel">
        <article className="carouselContent">
          <span className="arrow prev" onClick={this.prevSlide.bind(this)}></span>
          <span className="arrow next" onClick={this.nextSlide.bind(this)}></span>
          {slides}
          {carouselNav}
        </article>
      </div>
    );
  }
}

export default Carousel;


// WEBPACK FOOTER //
// ./src/Components/Carousel.js